import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=0bd4b0ba&shadow"
import script from "./Tracking.vue?vue&type=script&lang=ts&shadow"
export * from "./Tracking.vue?vue&type=script&lang=ts&shadow"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports